import { PatientProfileResponse } from './patient-profile';

export interface FindPatientIdParams {
  patientId?: string;
  onSettled?: () => void;
  onSuccess?: ((data: PatientProfileResponse | undefined) => void) | undefined;
  onError?: ((err: unknown) => void) | undefined;
}

export enum FindPatientIdError {
  NO_MATCHING_ID = 'NO_MATCHING_ID',
}
